export default "__VITE_ASSET__CygowZA5__"